var _path, _path2, _mask, _g, _mask2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4917 3.70745V7.77531C14.4917 8.16582 14.8086 8.48276 15.1992 8.48276C15.5897 8.48276 15.9066 8.16582 15.9066 7.77531V3.70745C15.9066 3.31694 15.5897 3 15.1992 3C14.8086 3 14.4917 3.31694 14.4917 3.70745Z",
    fill: "#20123A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1655 6.44884H17.2333C17.6238 6.44884 17.9408 6.1319 17.9408 5.74139C17.9408 5.35087 17.6238 5.03394 17.2333 5.03394H13.1655C12.7749 5.03394 12.458 5.35087 12.458 5.74139C12.458 6.1319 12.7749 6.44884 13.1655 6.44884Z",
    fill: "#20123A"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 11,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5.03427H15.9068V15.9404H5V5.03427Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4919 10.4873C14.4905 11.6659 14.0561 12.662 13.343 13.3766C12.6285 14.0897 11.6324 14.5241 10.4538 14.5255C9.27444 14.5241 8.27834 14.0897 7.56381 13.3766C6.8507 12.662 6.41632 11.6659 6.41491 10.4873C6.41632 9.30871 6.8507 8.31262 7.56381 7.59738C8.27834 6.88498 9.27444 6.4506 10.4538 6.44918C10.8443 6.44918 11.1612 6.13224 11.1612 5.74173C11.1612 5.35051 10.8443 5.03428 10.4538 5.03428C8.92 5.03215 7.5433 5.6151 6.56277 6.59704C5.58082 7.57757 4.99859 8.95428 5 10.4873C4.99859 12.0204 5.58082 13.3971 6.56277 14.3776C7.5433 15.3596 8.92 15.9418 10.4538 15.9404C11.9868 15.9418 13.3635 15.3596 14.344 14.3776C15.326 13.3971 15.9082 12.0204 15.9068 10.4873C15.9068 10.0968 15.5899 9.77987 15.1994 9.77987C14.8088 9.77987 14.4919 10.0968 14.4919 10.4873Z",
    fill: "#20123A"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 6,
    height: 6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1357 13.1695H18.6187V18.6524H13.1357V13.1695Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3432 14.3773L17.4111 18.4451C17.6877 18.7217 18.1348 18.7217 18.4114 18.4451C18.688 18.1685 18.688 17.7214 18.4114 17.4448L14.3435 13.3769C14.0669 13.1003 13.6198 13.1003 13.3432 13.3769C13.0666 13.6535 13.0666 14.1006 13.3432 14.3773Z",
    fill: "#20123A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.b9e4e201.svg";
export { ForwardRef as ReactComponent };